import { useEffect, useState } from 'react'
import AdminMenu from './AdminMenu'

const AdminLayout = ({ title, subtitle, children }) => {
  const [collapsed, setCollapsed] = useState(false)
  useEffect(() => {
    try {
      const saved = localStorage.getItem('admin_menu_collapsed')
      if (saved === '1') setCollapsed(true)
    } catch {}
  }, [])
  const handleToggle = () => {
    setCollapsed(c => {
      const next = !c
      try { localStorage.setItem('admin_menu_collapsed', next ? '1' : '0') } catch {}
      return next
    })
  }
  return (
    <div className="min-h-screen bg-gray-100">
      <div className="container-custom py-8">
        <div className="mb-8">
          <h1 className="text-4xl font-bold mb-2"><span className="text-gradient">{title}</span></h1>
          {subtitle && <p className="text-xl text-gray-600">{subtitle}</p>}
        </div>
        <div className="grid gap-8" style={{ gridTemplateColumns: collapsed ? '80px 1fr' : '1fr 3fr' }}>
          <div>
            <AdminMenu collapsed={collapsed} onToggle={handleToggle} />
          </div>
          <div>
            {children}
          </div>
        </div>
      </div>
    </div>
  )
}

export default AdminLayout


